/**
 * src/lib/photoStore.js
 *
 * IndexedDB persistence for captured gallery photos.
 * Saves the generated JPEG dataUrl plus metadata needed by the UI.
 */

import { openDB } from "idb";

const DB_NAME = "blockamatic";
const DB_VERSION = 2;
const STORE_NAME = "photos";
const TOKENS_STORE_NAME = "tokens";

async function getDB() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        // Key is `id` (string)
        db.createObjectStore(STORE_NAME, { keyPath: "id" });
      }
      // Ensure the tokens store exists even if photoStore opens first.
      // Otherwise tokenStore operations can fail with NotFoundError.
      if (!db.objectStoreNames.contains(TOKENS_STORE_NAME)) {
        db.createObjectStore(TOKENS_STORE_NAME, { keyPath: "styleId" });
      }
    },
  });
}

export async function savePhoto(photo) {
  if (!photo?.id) throw new Error("savePhoto requires photo.id");
  const db = await getDB();
  await db.put(STORE_NAME, photo);
}

export async function getAllPhotos() {
  const db = await getDB();
  const all = await db.getAll(STORE_NAME);
  // Newest first (matches the UI’s prepend ordering)
  all.sort((a, b) => (b.ts || 0) - (a.ts || 0));
  return all;
}

export async function deletePhoto(id) {
  const db = await getDB();
  await db.delete(STORE_NAME, id);
}

